function Home() {
    return <img className="homeImg" src="https://i.pinimg.com/originals/a6/36/7e/a6367e8652dbdbd51d8df302d3409885.jpg" alt="Black-and-white illustration of a Stormtrooper helmet from Star Wars. And Star Wars Logo"></img>
}

export default Home;